const store = {
    namespaced: true,
    state:{
        resetQuiz: false,
        closeQuiz: false
    },
    mutations:{
        doResetQuiz(state){
            state.resetQuiz = true;
        },
        doNotResetQuiz(state){
            state.resetQuiz = false;
        },
        doCloseQuiz(state){
            state.closeQuiz = true;
        },
        doNotCloseQuiz(state){
            state.closeQuiz = false;
        },
    },
    actions:{
     
       
    },
    getters:{

    },
    modules:{
      
    },


}

export default store;